import { Tooltip } from 'antd';
import React from 'react';
import { isUnitsFeatureEnabledForLibrary } from '../../hooks/useInventoryUnitsFeature';
import OrderItemStaffSelect from './OrderItemStaffSelect';
import StaffNameCell from './StaffNameCell';
import {
  isReassignableOrderItem,
  isRoleLockedForItem,
  ORDER_ITEM_STAFF_ROLES,
  ROLE_LOCKED_MESSAGES,
} from './constants';

const createOrderItemStaffColumns = ({
  isLibrary = false,
  canEdit = true,
  onReassigned,
}) => (getLibraryId, isHidden = false) =>
  Object.values(ORDER_ITEM_STAFF_ROLES).map((staffRole) => ({
    title: staffRole?.label?.toUpperCase(),
    dataIndex: staffRole?.field,
    key: staffRole?.field,
    width: 250,
    align: 'left',
    hidden: isHidden,
    onCell: () => ({
      onClick: (e) => e?.stopPropagation(),
    }),
    render: (user, record) => {
      if (
        !canEdit ||
        !isReassignableOrderItem(record) ||
        (getLibraryId &&
          !isUnitsFeatureEnabledForLibrary(getLibraryId?.(record)))
      ) {
        return <StaffNameCell user={user} />;
      }
      const isLocked = isRoleLockedForItem(record, staffRole?.key);
      return (
        <Tooltip
          title={isLocked ? ROLE_LOCKED_MESSAGES?.[staffRole?.key] : ''}
          placement="top"
          zIndex={4}
        >
          <div>
            <OrderItemStaffSelect
              orderItem={record}
              staffRole={staffRole}
              libraryId={getLibraryId?.(record)}
              isLibrary={isLibrary}
              disabled={isLocked}
              onReassigned={onReassigned}
            />
          </div>
        </Tooltip>
      );
    },
  }));

export default createOrderItemStaffColumns;
